import loaderLatir from "../assets/img/loader-latir.svg"

export default function Loading() {
  return (
    <div className="latir-logo-wrapper h-96 w-96 flex justify-center items-center bg-white">
      <img src={loaderLatir} className="w-32 h-32 latir-logo" alt="Loader Latir"/>
    </div>
  );
}
